import {
  ApproveRequisitionDocument,
  ApproveRequisitionMutation,
  ApproveRequisitionMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useApproveRequisition = (variables: ApproveRequisitionMutationVariables) => {
  const [approveRequisitionMutation, { loading }] = useMutation(ApproveRequisitionDocument, {
    extractorFn: (data: ApproveRequisitionMutation) => data.atsMutations.approveAtsRequisition,
  })

  return {
    loading,
    approveRequisition() {
      return approveRequisitionMutation({ variables })
    },
  }
}
